// components/ModeSwitcher.js
import React from 'react';
import styled from 'styled-components';

const SwitcherContainer = styled.div`
  display: flex;
  margin-top: 16px;
`;

const SwitcherButton = styled.button`
  flex: 1;
  padding: 6px;
  font-size: 16px;
  background-color: ${props => (props.active ? '#0052CC' : '#f4f5f7')};
  color: ${props => (props.active ? '#fff' : '#505f79')};
  border: none;
  cursor: pointer;
  text-align: center;
  transition: 0.5s;

  &:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  &:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  &:hover {
    background-color: ${props => (props.active ? '#0052CC' : '#ebecf0')};
  }

  &:focus {
    outline: none;
  }
`;

const ModeSwitcher = ({ mode, onChange }) => (
  
  <SwitcherContainer>
    <SwitcherButton
      type='button'
      active={mode === 'filter'}
      onClick={() => onChange('filter')}
    >
      Использовать фильтры
    </SwitcherButton>
    <SwitcherButton
      type='button'
      active={mode === 'upload'}
      onClick={() => onChange('upload')}
    >
      Загрузка файла
    </SwitcherButton>
    <SwitcherButton
      type='button'
      active={mode === 'text'}
      onClick={() => onChange('text')}
    >
      Вставить текст
    </SwitcherButton>
  </SwitcherContainer>
);

export default ModeSwitcher;